module.exports = {"510823100":"普安镇","510823101":"龙源镇","510823103":"盐店镇","510823104":"柳沟镇","510823105":"武连镇","510823106":"东宝镇","510823107":"开封镇","510823108":"元山镇","510823109":"演圣镇","510823110":"王河镇","510823111":"公兴镇","510823112":"金仙镇","510823113":"香沉镇","510823114":"白龙镇","510823115":"鹤龄镇","510823116":"杨村镇","510823117":"羊岭镇","510823118":"江口镇","510823119":"木马镇","510823120":"剑门关镇","510823121":"汉阳镇","510823122":"下寺镇","510823123":"涂山镇","510823124":"店子镇","510823126":"张王镇","510823127":"姚家镇","510823128":"义兴镇","510823210":"秀钟乡","510823228":"樵店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510823.json
// module id = 2445
// module chunks = 0